import { Box, Button, ButtonGroup, CardActions, CardContent, Input, makeStyles, TextField, Typography, useMediaQuery, useTheme } from '@material-ui/core';
import clsx from 'clsx';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { requestWhitelabelCustomerValidation } from 'services/authentication.service';

import { usePinInput } from 'react-pin-input-hook'
import { Alert } from '@material-ui/lab';
import { Chat } from 'pages/CustomerBooking/Chat';
import { openChatState, SUPPORT_CHAT } from 'pages/CustomerBooking';
import { useSetRecoilState } from 'recoil';
import { useAnalytics } from '@zennya/web-component-library/src';
import { useTrackEvent, useTrackPage } from 'util/trackEvent';

const useStyles = makeStyles((theme) => {
  return {
    dateInput: {
      '& > input:nth-child(3)': {
        marginLeft: theme.spacing(1.5),
      },
      '& > input:nth-child(5)': {
        marginLeft: theme.spacing(1.5),
      }
    },
    center: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
    actions: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
    },
    pinContainer: {
      display: 'flex',
      alignItems: 'baseline',
      flexDirection: 'row',
    },
    pinField: {
      width: theme.spacing(7),
      height: theme.spacing(7),
      margin: theme.spacing(.5),
      [theme.breakpoints.down('sm')]: {
        width: theme.spacing(4),
        height: theme.spacing(4),
        margin: theme.spacing(0),
      },

      '& > div': {
        [theme.breakpoints.down('sm')]: {
          borderRadius: 5,
        }
      },
      '& > div > input': {
        textAlign: 'center',
        [theme.breakpoints.down('sm')]: {
          padding: 0,
          margin: theme.spacing(1)
        },
      }
    },
    pinDivider: {
      width: theme.spacing(2),
      textAlign: 'center'
    }
  }
})

function useWidth() {
  const theme = useTheme();
  const keys = [...theme.breakpoints.keys].reverse();
  return (
    keys.reduce((output, key) => {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const matches = useMediaQuery(theme.breakpoints.up(key));
      return !output && matches ? key : output;
    }, null) || 'xs'
  );
}

const AltPinCodeBirthDay = ({
  onVerificationComplete = () => { },
  customer,
  client,
  serviceId
}) => {
  const classes = useStyles()
  const setChatOpen = useSetRecoilState(openChatState);
  const [error, setError] = useState();
  
  const trackEvent = useTrackEvent(serviceId)
  const trackPage = useTrackPage(serviceId)

  const { fields } = usePinInput({
    onComplete: (value) => {
      setDateCode(value)
    },
    autoFocus: true,
    type: 'numeric',
    defaultValues: new Array(8).fill(''),
  })

  const screenWidth = useMediaQuery((theme) => theme.breakpoints.down("xs"), {
    noSsr: true,
  }) ? 'xs' : 'lg';

  const [dateCode, setDateCode] = useState('');

  useEffect(
    () => {
      if (customer && client && serviceId) {
        trackPage('Verification Page ', { booking_id: serviceId })
      }
    }, []
  );

  

  const doExistenceCheck = useCallback(
    async () => {
      try {
        setError()
        const result = await requestWhitelabelCustomerValidation({
          customerId: customer?.id,
          clientId: client?.id,
          code: dateCode
        })
        onVerificationComplete({
          identifier: result?.identifier,
          code: result?.code,
          expiry_date: result?.expiry_date
        })
      } catch (error) {
        let errMessage = ''
        if (error?.response?.data?.code === 'BIRTHDATE_VALIDATION_FAILED') {
          setError('Wrong Birthdate')
          errMessage = 'Wrong Birthdate'
        } else if (error?.response?.data?.code === 'INVALID_PARAMETERS') {
          setError('Invalid Date')
          errMessage = 'Invalid Date'
        } else {
          setError(error?.response?.data?.message?.en ?? error?.response?.data?.details ?? error?.message)
          errMessage = error?.response?.data?.message?.en ?? error?.response?.data?.details ?? error?.message
        }
        trackEvent('Verification Page Error', { booking_id: serviceId, error: errMessage, datecode: dateCode, customer_id: customer?.id, client_id: client?.id })
      }
    },
    [dateCode],
  );

  const renderPinField = useMemo(
    () => {
      const placeholder = 'MMDDYYYY'
      return fields?.map((fieldProps, index) => {
        const tf = <TextField
          className={classes.pinField}
          key={index}
          variant="outlined"
          inputProps={{
            ...fieldProps,
            placeholder: placeholder[index],
          }}
        />
        if (index === 1 || index === 3) {
          return (
            <>
              {tf}
              <Typography className={classes.pinDivider} variant="h6">/</Typography>
            </>
          )
        } else {
          return tf
        }

      })
    }, [fields]
  );
  return (
    <>
      <Typography className={classes.helv} variant="h3">Verification</Typography>
      <CardContent>
        <Typography variant="body2">Enter your birthdate to verify your identity</Typography>
      </CardContent>
      <CardContent className={classes.center}>
        <div className={classes.pinContainer}>
          {renderPinField}
        </div>
      </CardContent>
      {error &&
        <CardContent>
          <Alert severity='error'>{error}</Alert>
        </CardContent>
      }
      <CardActions className={classes.actions}>
        <Button variant="outlined" color="primary" onClick={() => {
          trackEvent('Verification - Chat Support - click')
          setChatOpen(SUPPORT_CHAT)
        }}>Chat support</Button>
        <Button variant="contained" color="primary" onClick={() => {
          trackEvent('Verification - Proceed - click')
          doExistenceCheck()
        }}>Proceed</Button>
      </CardActions>
      {/* <Chat disableMedical serviceId={serviceId} /> */}
    </>
  )
}

export { AltPinCodeBirthDay }